import React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { useFileDownloader } from 'Utilities';
import DownloadIcon from '@mui/icons-material/Download';
import { DownloadFileText, FileModel, IconButton } from '@techsharegov/react-ui';

export type FileDownloadCellProps = {
  fileControllerEndpoint: string;
  optionalParams?: any;
  fileId?: string;
  filename?: string;
  display?: any;
  endpointActionName?: string;
  className?: string;
};

export const FileDownloadCell: React.FC<
  GridCellProps & FileDownloadCellProps
> = ({ dataItem, fileId, filename, ...downloadFileTextProps }) => {
  const rowModel = dataItem as FileModel;
  const fileName = filename || rowModel.fileName;
  const entityId = fileId || rowModel.id;

  return (
    <td className="whitespace-preline" style={{ overflowWrap: 'anywhere' }}>
      <DownloadFileText
        fileId={entityId}
        filename={fileName}
        {...downloadFileTextProps}
      />
    </td>
  );
};

export type FileDownloadButtonCellProps = {
  endpoint: string;
  entityName: string;
  title?: string;
  icon?:  any;
};

export const FileDownloadButtonCell: React.FC<GridCellProps & FileDownloadButtonCellProps> = ({ 
  dataItem, 
  endpoint, 
  entityName, 
  title,
  icon = undefined,
  ...downloadFileTextProps 
}) => {
  const { downloadFile } = useFileDownloader();
  const downloadClick = async () => {
    downloadFile(endpoint, entityName);
  };
  return (
    <td className="whitespace-preline">
      <IconButton
        title={title}
        className="k-icon"
        iconElement={icon === undefined ? DownloadIcon : icon}
        onClick={downloadClick}
      ></IconButton>
    </td>
  );
};
